import { render } from "./NewBusinessRule.vue?vue&type=template&id=6f35efc3"
import script from "./NewBusinessRule.vue?vue&type=script&lang=js"
export * from "./NewBusinessRule.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__